export const toFixedNumber = (value: number, fractionDigits: number): number =>
  parseFloat(Number(value).toFixed(fractionDigits));
